module.exports = __webpack_public_path__ + "img/character.49a3a587.png";